import { mapState, mapActions, mapGetters } from 'vuex';
import { UPDATE_TARGETING_INFO } from '@/store/targetingInfo/actionTypes';

function defaultMutator(name) {
  return {
    update: (i) => ({ [name]: i }),
    clear: () => ({ [name]: null }),
  };
}

function empty() {
  return {};
}

export default (name, mutator = empty) => ({
  methods: {
    ...mapActions({
      updateModel: UPDATE_TARGETING_INFO,
    }),
    onValueChange(e) {
      const { update } = this.mutator;
      this.updateModel(update(e));
    },
    onClear() {
      const { clear } = this.mutator;
      this.updateModel(clear());
    },
  },
  computed: {
    ...mapState({
      modelValue: (state) => state.targetingInfo.data[name],
    }),
    ...mapGetters(['showDataFillingHint']),
    isEmpty() {
      return !this.modelValue;
    },
    warning() {
      return this.showDataFillingHint && this.isEmpty;
    },
    mutator() {
      return { ...defaultMutator(name), ...mutator(name) };
    },
  },
});
